import { render, staticRenderFns } from "./DeviceGroupTable.vue?vue&type=template&id=571362b2"
import script from "./DeviceGroupTable.vue?vue&type=script&lang=js"
export * from "./DeviceGroupTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports